import { Outlet } from "react-router-dom";
import TopNavBar from "../pages/TopNavBar";
import BottomNavBar from "../components/BottomNavBar";
import { AppCredits } from "../components/AppCredits";

/**
 * Signed-in layout. Phones: top bar + bottom tabs. Tablet and up: header with
 * the navigation and the page in a centred column.
 *
 * `focus` pages (new order, order details, success) have their own back-button
 * header on phones, so the app bars only show from tablet width up.
 */
export default function MainLayout({ focus = false }: { focus?: boolean }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className={focus ? "hidden md:block" : ""}>
        <TopNavBar />
      </div>
      <main
        className={`flex-1 w-full md:max-w-6xl md:mx-auto md:px-6 md:py-8 ${focus ? "" : "pb-24 md:pb-10"}`}
      >
        <Outlet />
      </main>
      {/* Desktop only: phones have the bottom tab bar there */}
      <footer className="hidden md:block border-t border-gray-100 bg-white">
        <AppCredits className="max-w-6xl mx-auto px-6 py-4 text-xs" />
      </footer>
      {!focus && <BottomNavBar />}
    </div>
  );
}
